import React from 'react';
import Button from "../../../components/ui/Button/Button";
import {NewChatData, useNewChatStore} from "../../../store";
import {ArrowRight} from "lucide-react";
import StepAside from "../StepAside";

const Step3 = () => {

    const {currentStep, setStep, newChatData, updateChatData} = useNewChatStore();

    const selectTheApp = (person: NewChatData['person_to_copy']) => {
        updateChatData({person_to_copy: person})
    }

    return (
        <div className="StepLayout">
            <div className="StepLayout__left">
                <span className="eyebrow">Step {currentStep} of 4</span>
                <h2>Who should the AI become?</h2>
                <p className="StepLayout__description">We found {newChatData.chat_members?.length || 0} people in this
                    chat. Choose the one whose personality and writing style the AI should copy.</p>

                <div className="StepLayout__people">
                    {
                        newChatData.chat_members?.map((el, idx) => (
                            <button type="button" key={el + idx} onClick={() => selectTheApp(el)}
                                    aria-pressed={newChatData.person_to_copy === el}
                                    className={`StepLayout__selector_option ${newChatData.person_to_copy === el ? 'active' : ''}`}>
                                <span className="StepLayout__personInitial">{el.trim().slice(0, 1).toUpperCase()}</span>
                                <h3>{el}</h3>
                                <div className='circle'/>
                            </button>
                        ))
                    }
                </div>

                <div className="StepLayout__buttons">
                    <Button type={'button'} onClick={() => setStep(currentStep - 1)} variant={'secondary'}
                            title={'Back'}/>
                    <Button type={'button'} disabled={!newChatData.person_to_copy}
                            onClick={() => setStep(currentStep + 1)} variant={'primary'} title={'Continue'}
                            icon={<ArrowRight size={16}/>}/>
                </div>

            </div>

            <StepAside title="Tip">
                Only this person's messages are used to learn their style. Your own messages give the AI context
                about how you two talk.
            </StepAside>
        </div>
    );
};

export default Step3;
